<mat-card class="md:min-w-[29rem] md:w-[29rem]">
  <mat-card-content class="flex flex-col gap-y-3">
    <div class="text-headline-large">Create a Password</div>
    <div class="text-body-large mb-8">
      <p>Provide a password to complete the setup of your library account. If any account details are incorrect, please
        contact your local library directly.</p>
    </div>

    <px-confirmed-password-form-field fieldName="password" [formGroup]="createPasswordForm"/>

    @if (forLookupContext) {
      <mx-select-form-field fieldName="branchId" overrideLabel="Pickup Location" [formGroup]="createPasswordForm"
                            [options]="branchSelectors.pickupLocationsSelectOptions | select:[]"
                            [includeUndefinedOption]="false"/>
    }
    <mx-checkbox-form-field fieldName="acceptTerms" [formGroup]="createPasswordForm" overrideLabel="">
      <div class="flex flex-row items-center text-title-medium">
        I agree to the
        <mx-text-button label="terms and conditions." href="https://www.simplicity-ils.com/terms-of-service"/>
      </div>
    </mx-checkbox-form-field>
    <mx-filled-button label="Submit" [enabled]="createPasswordForm.valid" (click)="onClickNext()"/>
  </mat-card-content>
</mat-card>

<mat-card class="w-full h-fit md:w-fit md:min-w-[17rem] grow lg:grow-0">
  <mat-card-content>
    <div class="text-headline-medium mb-3">Your Details</div>
    <div class="flex flex-row md:flex-col gap-3">
      <div class="w-full flex flex-col gap-y-3">
        @let detailsSelectors = forLookupContext ? patronSelectors : registrationSelectors;
        <div class="text-title-large">{{ detailsSelectors.fullName | select }}</div>
        <div>
          <div class="text-body-large">{{ detailsSelectors.address | select }}</div>
          <div class="text-body-large">{{ detailsSelectors.cityStateZip | select }}</div>
        </div>

        @let cardNumber = (forLookupContext ? patronSelectors.barcode : registrationSelectors.cardNumber) | select;
        @let dob = detailsSelectors.dateOfBirth | select;
        @let branchName = branchSelectors.branchNameForId(createPasswordForm.value.branchId) | select;
        <mx-detail-field [titleText]="forLookupContext ? 'Username:' : 'Email'"
                         [value]="registrationSelectors.email | select"/>
      </div>
      <div class="w-full flex flex-col gap-y-3">
        @if (forLookupContext && cardNumber) {
          <mx-detail-field titleText="Library Card Number:" [value]="cardNumber"/>
        }
        @if (dob) {
          <mx-detail-field titleText="DOB:" [value]="dob | format:'DATE_ONLY'"/>
        }
        @if (!forLookupContext && branchName) {
          <mx-detail-field titleText="Pickup Branch:" [value]="branchName"/>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>
<div class="max-w-[33%] overflow-hidden ml-4 hidden lg:flex">
  <img ngSrc="/assets/registration/create-password.png" priority width="276" height="540" alt=""
       class="hidden lg:flex lg:max-w-[17.25rem]"/>
</div>
